import { __assign } from "tslib";
import { messageSignature } from './constants';
var Messager = /** @class */ (function () {
    function Messager(self, target, ready) {
        var _this = this;
        this.onmessage = (function () { });
        this._self = self;
        this._target = target;
        this._ready = ready || false;
        this._readyCallback = [];
        this._messageListener = function (e) {
            try {
                var message = JSON.parse(e.data);
                if (message[messageSignature]) {
                    if (!_this._ready) {
                        _this._ready = true;
                        _this._readyCallback.forEach(function (c) {
                            c();
                        });
                        _this._readyCallback = [];
                    }
                    delete message[messageSignature];
                    _this.onmessage(message);
                }
            }
            catch (e) { }
        };
        this._self.addEventListener('message', this._messageListener);
    }
    Messager.prototype.post = function (data, force) {
        var _this = this;
        var func = function () {
            var _a;
            try {
                _this._target.postMessage(JSON.stringify(__assign(__assign({}, data), (_a = {}, _a[messageSignature] = true, _a))), '*');
            }
            catch (e) { }
        };
        if (this._ready || force) {
            func();
        }
        else {
            this._readyCallback.push(func);
        }
    };
    Messager.prototype.destroy = function () {
        this._self.removeEventListener('message', this._messageListener);
    };
    return Messager;
}());
export default Messager;
